import React from 'react';
import {Link} from 'react-router-dom'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import 'react-sticky-header/styles.css';
import MobileMenu from '../../components/MobileMenu'
import { useSiteSettings } from '../../siteSettings'



import './style.css'

const Header = () => {
    const settings = useSiteSettings();
    const [activeLink, setActiveLink] = React.useState('home');
    const sectionIsVisible = (id) => {
        const layout = settings.sectionLayout;
        if (!layout || !layout.length) return true;
        const section = layout.find((item) => item.id === id);
        return !section || section.visible !== false;
    };
    const sectionHasContent = (id) => id !== 'gallery' || Boolean(
        settings.gallerySection &&
        Array.isArray(settings.gallerySection.items) &&
        settings.gallerySection.items.some((item) => item && item.image)
    );

    const activate = (link) => () => {
        setActiveLink(link);
        if (link === 'home') window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return(

          <div className="Header_root">
            <div className="header">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3">
                            <div className="logo">
                                <h2><Link to='/'>{settings.coupleNames}</Link></h2>
                            </div>
                        </div>
                        <div className="col-lg-9">
                            <div className="header-menu d-lg-block d-none">
                                <ul className="mobail-menu d-flex">
                                    {sectionIsVisible('hero') && <li><Link className={activeLink === 'home' ? 'active' : ''} onClick={activate('home')} to='/'>Accueil</Link></li>}
                                    {sectionIsVisible('couple') && <li><AnchorLink className={activeLink === 'couple' ? 'active' : ''} onClick={activate('couple')} href='#couple'>Les mariés</AnchorLink></li>}
                                    {sectionIsVisible('story') && <li><AnchorLink className={activeLink === 'story' ? 'active' : ''} onClick={activate('story')} href='#story'>Notre histoire</AnchorLink></li>}
                                    {sectionIsVisible('event') && <li><AnchorLink className={activeLink === 'event' ? 'active' : ''} onClick={activate('event')} href='#event'>Événements</AnchorLink></li>}
                                    {sectionIsVisible('gallery') && sectionHasContent('gallery') && <li><AnchorLink className={activeLink === 'gallery' ? 'active' : ''} onClick={activate('gallery')} href='#gallery'>Galerie</AnchorLink></li>}
                                    {sectionIsVisible('rsvp') && <li><AnchorLink className={activeLink === 'rsvp' ? 'active' : ''} onClick={activate('rsvp')} href='#rsvp'>RSVP</AnchorLink></li>}
                                </ul>
                            </div>
                        </div>
                        <div className="col-12">
                            <MobileMenu/>
                        </div>
                    </div>
                </div>
             </div>
          </div>
        
    )
}

export default Header;
